import { createSelector } from '@reduxjs/toolkit';

// Models
import { IWidgetSettingsState } from './widget-settings.slice';
import { TRootState } from '../index';

/**
 A selector function to retrieve the widget settings data from the store
 @function
 @param {TRootState} state - The root state of the Redux store
 @returns {IWidgetSettingsState} The widget settings state object from the Redux store
 */
const selectWidgetSettingsState = (state: TRootState): IWidgetSettingsState => state.widgetSettings;

/**
 A memoized selector function to retrieve the widget settings data from the store
 @function
 @type {import('@reduxjs/toolkit').OutputSelector<RootState, IWidgetSettingsState, (res: IWidgetSettingsState) => IWidgetSettingsState>}
 */
export const getWidgetSettingsState = createSelector(
  [selectWidgetSettingsState],
  (state): IWidgetSettingsState => state
);
